import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { Typography } from "@insite/mobius/index";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageWithoutLinkStyles;
    showSmallImage?: boolean;
}

type Props = OwnProps;

export interface ProductImageWithoutLinkStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageWithoutLinkStyles: ProductImageWithoutLinkStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
};

const ProductImageWithoutLink = ({ product, onClick, extendedStyles, showSmallImage }: Props) => {
    const [styles] = useState(() => mergeToNew(productImageWithoutLinkStyles, extendedStyles));
    
    let altText = "product" in product ? product.product.imageAltText : product.altText;
    if (!altText || altText === "") {
        altText = "product" in product ? product.product.productTitle : product.productName;
    }

    const imagePath =
        "product" in product
            ? showSmallImage
                ? product.product.smallImagePath || product.product.mediumImagePath
                : product.product.mediumImagePath || product.product.smallImagePath
            : product.smallImagePath;

    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";
     const [productDetailsPath, setproductDetailPath] = useState(productDetailPath);           
            useEffect(() => {
                if (typeof window !== "undefined") {
                    const params = new URLSearchParams(window.location.search);
                    const value = (params.get("query") || "").toLowerCase();
                    const manufNumber="product" in product? product.product.manufacturerItem.toLowerCase():"";
                    const customerProductNumbers =  "product" in product? product.product.customerProductNumber?.toLowerCase().split(",") || []:"";              
                    if ((value!=="" && value === manufNumber) || (customerProductNumbers.length>0 && customerProductNumbers.includes(value))) {
                        setproductDetailPath(`${productDetailPath}?criteria=${value}`);
                    }                
                }
            }, []);    

    return (
        <Typography
            {...styles.linkWrappingImage}
            onClick={onClick}
            data-test-selector="productImage"
        >
            <Img {...styles.img} loading={loading} width="209" height="209" src={imagePath} altText={altText} />
        </Typography>
    );
};

export default ProductImageWithoutLink;
